import React from "react";
import { Icon } from "@iconify/react";
import { Button } from "@/components/ui/button";
import LanguageToggle from "../language-toggle";
import BreadCrumb from "@/components/button/bread-crumb";
import ProfileDropdown from "@/components/dashboard/profile-dropdown";
import CompanySwitcher from "@/components/company/company-switcher";

interface props {
  setIsSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isSidebarOpen: boolean;
  setIsSidebarMinimized: React.Dispatch<React.SetStateAction<boolean>>;
  isSidebarMinimized: boolean;
}

const DashboardNavbar: React.FC<props> = ({
  setIsSheetOpen,
  setIsSidebarMinimized,
  isSidebarMinimized,
}) => {
  return (
    <main className="h-[64px] transition-all duration-300 top-0 sticky bg-white flex items-center justify-between px-[1rem] w-full z-40">
      {/* Left section - Menu, Logo, Breadcrumb */}
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <button
          onClick={() => setIsSidebarMinimized(!isSidebarMinimized)}
          className="bg-[#F5F6FA] p-1.5 rounded-md text-gray-700 hidden xl:flex cursor-pointer"
        >
          <Icon icon="material-symbols:legend-toggle-rounded" fontSize={21} />
        </button>
        <Button
          variant="ghost"
          className="p-2 hover:bg-inherit cursor-pointer flex-shrink-0 xl:hidden"
          onClick={() => setIsSheetOpen(true)}
        >
          <Icon icon={"iconamoon:menu-burger-horizontal"} fontSize={24} />
        </Button>
        <img src="/uzaforms-logo-small.svg" alt="logo" className="w-[50px] flex-shrink-0 xl:hidden" />
        <div className="flex-1 min-w-0">
          <BreadCrumb />
        </div>
      </div>

      {/* Right section - Company Switcher, Language toggle and Profile */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <CompanySwitcher />
        <LanguageToggle />
        <ProfileDropdown />
      </div>
    </main>
  );
};

export default DashboardNavbar;
